import { gql, useQuery } from '@apollo/client';

const AUDIT_POLICY_SNIPPETS = gql`
  query AuditPolicySnippets(
    $page: Int
    $pageSize: Int
    $search: String
    $status: String
    $sortBy: String
    $sortOrder: String
  ) {
    auditPolicySnippets(
      page: $page
      pageSize: $pageSize
      search: $search
      status: $status
      sortBy: $sortBy
      sortOrder: $sortOrder
    ) {
      snippets {
        id
        description
        category
        serviceName
        snippet
        status
        approved
        createdAt
        updatedAt
      }
      total
      totalPending
      page
      pageSize
    }
  }
`;

export interface AuditPolicySnippetMerged {
  id: string;
  description: string;
  category: string | null;
  serviceName: string | null;
  snippet: string | null;
  status: 'cached' | 'NOT_STARTED' | 'GENERATING' | 'FAILED';
  approved: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface AuditPolicySnippetsResult {
  snippets: AuditPolicySnippetMerged[];
  total: number;
  totalPending: number;
  page: number;
  pageSize: number;
}

export interface AuditPolicySnippetsVariables {
  page?: number;
  pageSize?: number;
  search?: string;
  status?: 'pending' | 'cached';
  sortBy?: 'status' | 'serviceName' | 'categoryKey' | 'updatedAt' | 'createdAt' | 'description';
  sortOrder?: 'asc' | 'desc';
}

export interface AuditPolicySnippetsData {
  auditPolicySnippets: AuditPolicySnippetsResult;
}

export function useAuditPolicySnippetsQuery(variables?: AuditPolicySnippetsVariables) {
  return useQuery<AuditPolicySnippetsData, AuditPolicySnippetsVariables>(AUDIT_POLICY_SNIPPETS, {
    variables,
    fetchPolicy: 'network-only',
    pollInterval: 5000, // Poll every 5 seconds to get updates from background snippet generation
  });
}
